import React, { Component } from "react";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";

import { TopTextReusableComponent } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
// import {
//   ReusableOnboardingLink,
//   ReusableOnboardingButton,
// } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import isEmpty from "../../../../store/validation/is-Empty";

// import Switch from "react-switch";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import Media from "react-media";
import { HealthAndSenitationOthersFour } from "../../../vendorOnboradingComponents/allScreens/healthAndSenitation/InsideComponent/HealthAndSenitationOthersFour";

export class VendorHealthAndSenitationFoodHandlingEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editButton: false,
      actionButton: false,
      loader: false,
      hasSetMapProps: false,

      healthandsanitization_food_handling: [],
      // DATA
      selected_health_and_sanitization_food_handling: [],
      primary_health_and_sanitization_food_handling: {},
      errors: [],
    };
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: true,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.onboarding._id) &&
      !isEmpty(nextProps.health_handling) &&
      !nextState.hasSetMapProps
    ) {
      let selected_health_and_sanitization_food_handling =
        nextProps.onboarding.selected_health_and_sanitization_food_handling;
      let primary_health_and_sanitization_food_handling =
        nextProps.onboarding.primary_health_and_sanitization_food_handling;

      if (
        !isEmpty(
          nextProps.onboarding.primary_health_and_sanitization_food_handling
        ) &&
        !isEmpty(selected_health_and_sanitization_food_handling[0])
      ) {
        if (
          isEmpty(
            nextProps.onboarding.primary_health_and_sanitization_food_handling
          ) &&
          isEmpty(selected_health_and_sanitization_food_handling[0]._id) &&
          selected_health_and_sanitization_food_handling.length > 0 &&
          isEmpty(primary_health_and_sanitization_food_handling._id)
        ) {
          selected_health_and_sanitization_food_handling =
            nextProps.health_handling.filter((data) =>
              selected_health_and_sanitization_food_handling.includes(data._id)
            );
          primary_health_and_sanitization_food_handling =
            nextProps.health_handling.filter(
              (data) =>
                data._id === primary_health_and_sanitization_food_handling
            )[0];
        }
      }
      let all_healthandsanitization_food_handling =
        nextProps.health_handling.filter(
          (point) =>
            !selected_health_and_sanitization_food_handling.some(
              (selected) => selected._id === point._id
            )
        );

      return {
        selected_health_and_sanitization_food_handling: !isEmpty(
          selected_health_and_sanitization_food_handling
        )
          ? selected_health_and_sanitization_food_handling
          : [],
        primary_health_and_sanitization_food_handling: !isEmpty(
          primary_health_and_sanitization_food_handling
        )
          ? primary_health_and_sanitization_food_handling
          : {},
        healthandsanitization_food_handling:
          all_healthandsanitization_food_handling,
        healthAndSanitizeServicesCheck:
          nextProps.onboarding.healthAndSanitizeServicesCheck,
        hasSetMapProps: true,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  /********************************
   * @DESC Food Handling Handler
   ********************************/
  onFoodHandlingBackButton = (e) => {
    this.props.history.push("/profile");
  };

  whithOutFoodHandlingNextButton = (e) => {
    this.setState({
      actionButton: false,
    });
    this.props.history.push("/profile");
  };

  editClick = (e) => {
    this.setState({
      editButton: !this.state.editButton,
    });
  };

  onFoodHandlingNextButton = (e) => {
    let formData = {
      healthAndSanitizeServicesCheck: this.state.healthAndSanitizeServicesCheck,
      selected_health_and_sanitization_food_handling:
        this.state.selected_health_and_sanitization_food_handling,
      primary_health_and_sanitization_food_handling:
        this.state.primary_health_and_sanitization_food_handling,
      id: this.props.onboarding._id,
      vendor_id: this.props.onboarding.vendor_id,
    };
    this.props.create_and_update_restaurant(formData);
    this.setState({
      editButton: true,
      actionButton: false,
    });
  };

  othersHealthAndSafetyHandlerFour = (icon, index) => (e) => {
    let buttonArray = this.state.healthandsanitization_food_handling;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_health_and_sanitization_food_handling;
    let primaryIcon = this.state.primary_health_and_sanitization_food_handling;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_health_and_sanitization_food_handling: Restaurant,
        primary_health_and_sanitization_food_handling: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_health_and_sanitization_food_handling: Restaurant,
      actionButton: true,
    });
  };

  othersHealthAndSafetyPrimarySelectorFour = (icon) => (e) => {
    this.setState({
      primary_health_and_sanitization_food_handling: icon,
      actionButton: true,
    });
  };

  /****************************************
   * @DESC - Remove Primary button handler
   ****************************************/
  othersHealthAndSafetyRemoveButtonFour = (icon) => (e) => {
    let {
      healthandsanitization_food_handling,
      selected_health_and_sanitization_food_handling,
      primary_health_and_sanitization_food_handling,
    } = this.state;

    let iconIndexAtAllIcons = healthandsanitization_food_handling.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons =
      selected_health_and_sanitization_food_handling.findIndex(
        (icons) => icons._id === icon._id
      );
    let iconAtPrimaryIcon =
      !isEmpty(primary_health_and_sanitization_food_handling) &&
      primary_health_and_sanitization_food_handling._id === icon._id
        ? true
        : false;
    if (selected_health_and_sanitization_food_handling.length === 0) {
      selected_health_and_sanitization_food_handling.push(icon);
      healthandsanitization_food_handling.splice(iconIndexAtAllIcons, 1);
      primary_health_and_sanitization_food_handling = icon;
    } else if (iconAtPrimaryIcon) {
      selected_health_and_sanitization_food_handling.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_food_handling.push(icon);
      if (selected_health_and_sanitization_food_handling.length === 1) {
        primary_health_and_sanitization_food_handling =
          selected_health_and_sanitization_food_handling[0];
      } else {
        primary_health_and_sanitization_food_handling = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_health_and_sanitization_food_handling.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_food_handling.push(icon);
      if (selected_health_and_sanitization_food_handling.length === 1) {
        primary_health_and_sanitization_food_handling =
          selected_health_and_sanitization_food_handling[0];
      }
    } else {
      selected_health_and_sanitization_food_handling.push(icon);
      healthandsanitization_food_handling.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_health_and_sanitization_food_handling:
        selected_health_and_sanitization_food_handling,
      healthandsanitization_food_handling: healthandsanitization_food_handling,
      primary_health_and_sanitization_food_handling:
        primary_health_and_sanitization_food_handling,
      actionButton: true,
    });
  };

  servicesCheckSwitchValue = (e) => {
    // this.setState({
    //   selected_health_and_sanitization_food_handling: [],
    //   primary_health_and_sanitization_food_handling: {},
    // });
    this.setState({
      healthAndSanitizeServicesCheck:
        !this.state.healthAndSanitizeServicesCheck,
      actionButton: true,
    });
  };
  renderHealthsenitationFields = () => {
    const { actionButton, editButton, healthAndSanitizeServicesCheck } =
      this.state;
    return (
      <React.Fragment>
        <div className="restaurant_type_onboarding_main">
          <div>
            <HealthAndSenitationOthersFour
              bigText="What are the Hygiene and Sanitation options available for Food Handling practices"
              smallText="Please select items from the list below"
              primaryBigText="Out of the selections below, which one is primary?"
              primarySmallText="Select only one of the options below as a default - this is shown to the user."
              servicesCheck={healthAndSanitizeServicesCheck || this.state.editButton}
              servicesCheckHandler={this.servicesCheckSwitchValue}
              otherHealth={this.state.healthandsanitization_food_handling}
              selectedOtherHealth={
                this.state.selected_health_and_sanitization_food_handling
              }
              primaryOtherHealth={
                this.state.primary_health_and_sanitization_food_handling
              }
              onRestaurantSelectorArraySelector={
                this.othersHealthAndSafetyHandlerFour
              }
              onRestaurantsPrimarySelector={
                this.othersHealthAndSafetyPrimarySelectorFour
              }
              removeButton={this.othersHealthAndSafetyRemoveButtonFour}
              onBackButtonFourClick={this.onFoodHandlingBackButton}
              onNextButtonFourClick={
                // actionButton === false
                //   ? this.whithOutFoodHandlingNextButton
                //   :
                this.onFoodHandlingNextButton
              }
              protocolNext={editButton === true ? true : false}
              actionButton={actionButton}
            />
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    if (this.state.loader) {
      return <AmealioLoader />;
    }

    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/profile"
                displayText="Back"
              />
              <div className="col-12 col-md-6 bg-transparent pt-md-0 pt-lg-0 pt-xl-0">
                <div className="p-2">
                  <div>
                    <TopTextReusableComponent
                      headingText="Health and Sanitation"
                      headingParagraph="( Please enter information about the Hygiene and Sanitation efforts and protocol )"
                      displayEdit={this.state.editButton}
                      onClickEdit={this.editClick}
                    />
                  </div>
                  <Form noValidate onSubmit={this.onFoodHandlingNextButton}>
                    {this.renderHealthsenitationFields()}
                  </Form>
                </div>
              </div>
            </div>

            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

VendorHealthAndSenitationFoodHandlingEdit.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  health_handling: state.category.health_handling,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
})(withRouter(VendorHealthAndSenitationFoodHandlingEdit));
